export const KEY = "signIn";

export const SignInModes = Object.freeze({
  signUp: 0,
  signIn: 1,
  reauthForEmail: 2,
  reauthForDeletion: 3,
});

export const SignInScreens = Object.freeze({
  RequestEmail: "RequestEmail",
  RequestName: "RequestName",
  Verify: "Verify",
});
